


















































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import { DefaultCopy } from "../../../../plugins/copyobj";
import CarModel from "./CarModel.vue";
import {Car, ModelResponse, ModificationResponse} from "@/services/index.defs";

@Component({
    components: { CarModel },
})
export default class CarModelHost extends Vue {
    @Prop() car: Car;
    @Prop({default: false}) isEdit: boolean;

    get _isEdit(): boolean{ return this.isEdit };
    set _isEdit(val: boolean){
        this.$emit("update:isEdit",val);
        if(val){
            this.currMapModels = this.$store.direct.state.dicti.mapModels;
            this.currModifications = this.$store.direct.state.dicti.modifications;
        }
    };

    isCarValid: boolean = true;
    get getCarName(): string {
        //'Audi A5 245 л.с'
        const mark = !!this.car.markId
            ? this.$store.direct.state.dicti.mapMarks.find(
                (x) => x.id == this.car.markId
            )?.title
            : "";
        const model = !!this.car.modelId
            ? this.$store.direct.state.dicti.mapModels.find(
                (x) => x.id == this.car.modelId
            )?.title
            : "";
        if (!mark || !model) {
            this.isCarValid = false;
            return "Заполните информацию о машине!";
        } else {
            this.isCarValid = true;
            return `${mark} ${model} ${this.car.yearIssue} ${
                this.car.power ?? "-"
            } л.с`;
        }
    }
    changedCar: Car = DefaultCopy(this.car);


    currMapModels: ModelResponse[] = [];
    currModifications: ModificationResponse[] = [];

    @Ref("form") form: { validate: Function };
    saveCarModel() {
        let isValid = this.form.validate();
        if (!isValid) {
            //this.cancelCarModel();
            return;
        }

        this._isEdit = false;
        this.car.markId = this.changedCar.markId;
        this.car.modelId = this.changedCar.modelId;
        this.car.yearIssue = this.changedCar.yearIssue;
        this.car.power = this.changedCar.power;
        this.car.modificationId = this.changedCar.modificationId;
    }
    cancelCarModel() {
        this._isEdit = false;
        this.changedCar = DefaultCopy(this.car);
        this.$store.direct.commit.dicti.setMapModels(this.currMapModels);
        this.$store.direct.commit.dicti.setModification(this.currModifications);
    }
}
